module.exports = __webpack_public_path__ + "static/media/pampilhosa-4.e64199de.jpg";